import serviceModule from '@/store/modules/ServiceModule'
import { Customer } from '@/services/connecteur'
import moment from 'moment'
import store from '@/store'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
type Dictionary<T> = { [key: string]: T }

@Module({ namespaced: true, name: 'customerModule', dynamic: true, store })
export class CustomerModule extends VuexModule {
  private customerCache: Dictionary<Customer[]> = {}
  private cacheExpiration: Dictionary<Date> = {}

  @Mutation
  private updateCustomerListCache(list: Customer[]) {
    if (list.length > 0 && list[0].salesOrgId) {
      const salesOrgId = list[0].salesOrgId.toString()
      this.customerCache[salesOrgId] = list
      this.cacheExpiration[salesOrgId] = new Date()
    }
  }

  @Mutation
  private updateCustomerCache(customer: Customer) {
    if (customer.salesOrgId) {
      const salesOrgId = customer.salesOrgId.toString()
      const index = this.customerCache[salesOrgId].findIndex(
        c => c.id === customer.id
      )
      this.customerCache[salesOrgId].splice(index, 1, customer)
    }
  }

  @Action({ rawError: true })
  public async getCustomers(salesOrgId: number): Promise<Customer[]> {
    let result = new Array<Customer>()
    try {
      let isExpired = true

      if (this.customerCache[salesOrgId.toString()] && !isExpired) {
        const today = new Date().getTime()
        const dateLastRequest = this.cacheExpiration[
          salesOrgId.toString()
        ].getTime()
        const duration = moment.duration(today - dateLastRequest)
        isExpired = duration.asMinutes() >= 5
        if (!isExpired) {
          result = this.customerCache[salesOrgId]
        }
      }

      if (isExpired) {
        result = await serviceModule.customerApi.getAll(salesOrgId)
        this.updateCustomerListCache(result)
      }
    } catch (error) {
      return Promise.reject(error)
    }

    return Promise.resolve(result)
  }

  @Action({ rawError: true })
  public async updateCustomer(customer: Customer): Promise<Customer> {
    try {
      const customerUpdated = await serviceModule.customerApi.updateCustomer(customer)
      this.updateCustomerCache(customerUpdated)
      return customerUpdated
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default getModule(CustomerModule)
